import {useCallback, useEffect, useMemo, useState} from "react";
import _ from "lodash";
import {ClientReportSubmitInput, isShortAddendumReport} from "../domain";
import { UseFormReturn } from "react-hook-form";
import {StaffingAddendumType} from "../staffing-plan/domain";

type Args = {
    methods: UseFormReturn<ClientReportSubmitInput, object>;
    staffingAddendumReportType: StaffingAddendumType;
};
export function useStaffingAddendumReports({
                                               methods,
                                               staffingAddendumReportType
                                           }: Args) {
    // report type is fixed / unchangeable if this modal is used for addendum staffing action
    const isStaffingAddendum = useMemo(() => !_.isEmpty(staffingAddendumReportType), [staffingAddendumReportType]);
    const isStaffingShortAddendum = useMemo(() => isShortAddendumReport(staffingAddendumReportType), [staffingAddendumReportType]);
    const [isShortAddendum, setIsShortAddendumRaw] = useState(isStaffingShortAddendum);
    const setIsShortAddendum = useCallback((v: boolean) => {
        if (isStaffingShortAddendum) {
            setIsShortAddendumRaw(true);
        } else {
            setIsShortAddendumRaw(v);
        }
    }, [setIsShortAddendumRaw, isStaffingShortAddendum]);

    useEffect(() => {
        if (isStaffingAddendum) {
            methods.setValue('reportType', staffingAddendumReportType);
            if (isStaffingShortAddendum) {
                setIsShortAddendum(true);
            }
        } else {
            setIsShortAddendum(false);
        }
    }, [methods, staffingAddendumReportType, isStaffingAddendum, isStaffingShortAddendum, setIsShortAddendum]);

    return {
        isStaffingAddendum,
        isShortAddendum,
        setIsShortAddendum
    }
}
